module.exports = __webpack_public_path__ + "static/media/xlsx.cb7f7670.svg";